import { NotAuthorizedIllustration as NotAuthorizedIllustrationSvg } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EmptyState } from './EmptyState';

export const LowResults = (props: any) => (
    <EmptyState illustrationType={<NotAuthorizedIllustrationSvg />} {...props}>
        {gettext("Our magic algorithm thinks you'll like these options.")}
    </EmptyState>
);
